<template>
<div class="chapter">
<div class="inner_page">
<h2 class="head3">The Potting Shed</h2>
<p class="noindent1">produced by Carmen Capalbo and Stanley Chase, with scenery by Chester Rakeman Scenic Studios, was first presented on Tuesday, January 29, 1957, at the Bijou Theatre, New York. The cast was as follows:</p>
<table class="table1">
<tbody><tr>
<td class="spc">D<span class="small">R.</span> F<span class="small">REDERICK</span> B<span class="small">ASTON</span></td>
<td class="spc">Lewis Casson</td>
</tr>
<tr>
<td class="spc">A<span class="small">NNE</span> C<span class="small">ALLIFER</span></td>
<td class="spc">Carol Lynley</td>
</tr>
<tr>
<td class="spc">S<span class="small">ARA</span> C<span class="small">ALLIFER</span></td>
<td class="spc">Leueen MacGrath</td>
</tr>
<tr>
<td class="spc">M<span class="small">RS.</span> C<span class="small">ALLIFER</span></td>
<td class="spc">Sybil Thorndike</td>
</tr>
<tr>
<td class="spc">J<span class="small">OHN</span> C<span class="small">ALLIFER</span></td>
<td class="spc">Stanley Lemin</td>
</tr>
<tr>
<td class="spc">J<span class="small">AMES</span> C<span class="small">ALLIFER</span></td>
<td class="spc">Robert Flemyng</td>
</tr>
<tr>
<td class="spc">D<span class="small">R.</span> K<span class="small">REUZER</span></td>
<td class="spc">Rudolf Weiss</td>
</tr>
<tr>
<td class="spc">C<span class="small">ORNER</span></td>
<td class="spc">Richard Longman</td>
</tr>
<tr>
<td class="spc">M<span class="small">RS.</span> P<span class="small">OTTER</span></td>
<td class="spc">Eda Heinemann</td>
</tr>
<tr>
<td class="spc">M<span class="small">ISS</span> C<span class="small">ONNOLLY</span></td>
<td class="spc">Joan Croydon</td>
</tr>
<tr>
<td class="spc">F<span class="small">ATHER</span> W<span class="small">ILLIAM</span> C<span class="small">ALLIFER</span></td>
<td class="spc">Frank Conroy</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?7fb938fd